import React from 'react'

import { Stack } from '@zet/design-system/layout'
import { Text } from '@zet/design-system/typography'

export default function ErrorModal() {
  return (
    <Stack className="items-center justify-center bg-white">
      <Text>ErrorModal</Text>
    </Stack>
  )
}
